import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const getCustomersApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/users/customers`, { params });
};
